export function payableMoney(value:unknown,currency='GBP'){
 if(value==null||String(value).trim()==='')return 'Amount not recorded';
 const raw=String(value);if(!/^-?\d+(?:\.\d{1,2})?$/.test(raw))return 'Amount unavailable';
 const [whole,fraction='']=raw.split('.'),negative=whole!.startsWith('-');
 const digits=whole!.replace(/^-/,'').replace(/^0+(?=\d)/,'').replace(/\B(?=(\d{3})+(?!\d))/g,',');
 return `${negative?'−':''}${currency==='GBP'?'£':currency+' '}${digits}.${fraction.padEnd(2,'0')}`;
}
